module.exports = __webpack_public_path__ + "static/the-nurture-assumption-9d9897a503004a5d1e882116e7c0b64e.jpg";